export default function NotFoundPage() {
  return <div>
    <h2 className="page-title">Não encontrado</h2>
    <p>Página inexistente.</p>
  </div>;
}
